module.exports = "/public/images/d2edd19ee391b9095e1638e445ee242d.png";